import React from 'react';
import Box from '@amzn/meridian/box';
import Text from '@amzn/meridian/text';
import { AssignmentsMetrics } from '../models';

export interface MetricsBarProps {
  metrics: AssignmentsMetrics;
}

/**
 * Horizontal metrics bar displayed above the process-path sections on the
 * Assignments page. Pure presentational: renders two lines of aggregate
 * counts derived from the `metrics` prop and re-renders whenever the prop
 * changes.
 *
 * Line 1: associate counts (Unlocked, Clocked in, Actual).
 * Line 2: assignment counts per category (Primary, Problem solve, Resale,
 *         Clean decant, Indir).
 */
const MetricsBar: React.FC<MetricsBarProps> = ({ metrics }) => {
  const {
    totalUnlocked,
    totalClockedIn,
    totalActual,
    assignedPrimary,
    assignedProblemSolve,
    assignedResale,
    assignedCleanDecant,
    assignedIndirect,
  } = metrics;

  // Use template literals so each line renders as a single text node; this
  // keeps the exact labels contiguous for assistive tech and for tests.
  const associatesLine =
    `Associates: ${totalUnlocked} Unlocked, ` +
    `${totalClockedIn} Clocked in, ` +
    `${totalActual} Actual`;

  const assignedLine =
    `Assigned: ${assignedPrimary} Primary, ` +
    `${assignedProblemSolve} Problem solve, ` +
    `${assignedResale} Resale, ` +
    `${assignedCleanDecant} Clean decant, ` +
    `${assignedIndirect} Indir`;

  return (
    <Box className="assignments-metrics-bar" spacingInset="300">
      <Text type="b200">{associatesLine}</Text>
      <Text type="b200">{assignedLine}</Text>
    </Box>
  );
};

export default MetricsBar;
